import app from "js/legacy-app";

app.controller('RequestsStatisticsCtrl', ['$scope', function ($scope) {

    $scope.$parent.selectedTab = 2;

}]);
